//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "App",
  data() {
    return {
      className: ''
    };
  },
  created: function() {},
  mounted(){
    if(this.SERVER.APPID == 'mylink'){
      this.className = 'mylinkApp'
    }
  }
};



// WEBPACK FOOTER //
// ./src/App.vue